import { useState } from "react";
import {
  Box,
  Button,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import {
  Add as AddIcon,
  AccountBalance as BankIcon,
} from "@mui/icons-material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import InstrumentoRow from "./InstrumentoRow";
import SeleccionCreditosQr from "./SeleccionCreditosQr";

const ID_TIPO_NEGOCIO_ENVASADO = 3;

export default function InstrumentosTab({
  instrumentos,
  onAdd,
  clienteData,
  onUpdate,
  onRemove,
  onAddInstrumentosQr,
  tiposInstrumento,
  bancos,
  handleImporteChange,
}) {
  const [filaQrPendiente, setFilaQrPendiente] = useState(null);
  const [dialogoQrOpen, setDialogoQrOpen] = useState(false);
  // La columna "Fecha de pago" solo aplica a Cheque (3) y E-cheq (6): si no hay
  // ninguno cargado, ni siquiera mostramos el encabezado.
  const hayFechaDePago = instrumentos.some(
    (inst) => inst.tipo_id === 3 || inst.tipo_id === 6,
  );

  return (
    <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale="es">
      {instrumentos.length === 0 ? null : (
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 2,
          }}
        >
          <Typography variant="body2" color="text.secondary">
            Agregue cheques, echeqs, transferencias o créditos QR.
          </Typography>
          <Button variant="outlined" startIcon={<AddIcon />} onClick={onAdd}>
            Agregar instrumento
          </Button>
        </Box>
      )}

      {instrumentos.length === 0 ? (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 1,
            py: 0.5,
          }}
        >
          <BankIcon
            sx={{
              fontSize: 18,
              color: "text.disabled",
            }}
          />

          <Typography
            variant="body2"
            color="text.secondary"
            sx={{
              fontSize: "0.82rem",
            }}
          >
            No hay instrumentos bancarios agregados
          </Typography>

          <Button
            variant="text"
            size="small"
            onClick={onAdd}
            sx={{
              minWidth: "auto",
              p: 0,
              fontSize: "0.8rem",
              textTransform: "none",
            }}
          >
            Agregar
          </Button>
        </Box>
      ) : (
        <TableContainer component={Paper} variant="outlined">
          <Table size="small">
            <TableHead>
              <TableRow sx={{ bgcolor: "grey.100" }}>
                <TableCell>
                  <strong>Tipo</strong>
                </TableCell>
                <TableCell>
                  <strong>Banco</strong>
                </TableCell>
                <TableCell>
                  <strong>Nro Comp</strong>
                </TableCell>
                <TableCell>
                  <strong>Fecha de emisión</strong>
                </TableCell>
                {hayFechaDePago && (
                  <TableCell>
                    <strong>Fecha de pago</strong>
                  </TableCell>
                )}
                <TableCell>
                  <strong>Importe</strong>
                </TableCell>
                <TableCell>
                  <strong>CUIT Firma</strong>
                </TableCell>
                <TableCell width={50}></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {instrumentos.map((inst, index) => (
                <InstrumentoRow
                  cuit={clienteData?.cuit}
                  key={inst.id}
                  instrumento={inst}
                  index={index}
                  tiposInstrumento={tiposInstrumento}
                  bancos={bancos}
                  mostrarFechaDePago={hayFechaDePago}
                  onUpdate={onUpdate}
                  onRemove={onRemove}
                  handleImporteChange={handleImporteChange}
                  onSelectTipoQr={(idx) => {
                    setFilaQrPendiente(idx);
                    setDialogoQrOpen(true);
                  }}
                />
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}

      {clienteData?.id_negocio_cliente === ID_TIPO_NEGOCIO_ENVASADO && (
        <SeleccionCreditosQr
          open={dialogoQrOpen}
          idCliente={clienteData?.id}
          idsExcluidos={instrumentos
            .filter((i) => i.pago_combinado_id)
            .map((i) => i.pago_combinado_id)}
          onClose={() => {
            setDialogoQrOpen(false);
            // Si cancela, descarta la fila vacía que había quedado pendiente.
            if (filaQrPendiente != null) onRemove(filaQrPendiente);
            setFilaQrPendiente(null);
          }}
          onConfirmar={(creditos) => {
            if (filaQrPendiente != null) onRemove(filaQrPendiente);
            onAddInstrumentosQr(creditos);
            setFilaQrPendiente(null);
            setDialogoQrOpen(false);
          }}
        />
      )}
    </LocalizationProvider>
  );
}
